<script>
export default {
    name: 'TermsOfService',
    computed: {
        tos() {
            return this.$appConfig('TOS', false)
        },
        privacyPolicy() {
            return this.$appConfig('PRIVACY_POLICY', false)
        },
    },
    methods: {},
}
</script>

<template>
    <div>
        <div>
            <h1><strong>Conditions d'utilisation &amp; Politique de confidentialité</strong></h1>

            <p><strong>Shift Arcade Ventures LLC</strong></p>
            <p>Date d'entrée en vigueur : 28 juillet 2025</p>

            <h2><strong>1. Aperçu</strong></h2>
            <p>Ces Conditions d'utilisation et Politique de confidentialité (« Politique ») régissent les communications initiées par Shift Arcade Ventures LLC (« Shift Arcade Ventures », « nous », « notre » ou « nos »), y compris les SMS, e-mails et autres messages électroniques envoyés en lien avec :</p>
            <ul>
                <li>Communications générales de Shift Arcade</li>
                <li>Demandes de franchise et mises à jour liées aux franchises</li>
                <li>Engagement client au niveau pré-localisation ou réseau</li>
            </ul>
            <p>
                Shift Arcade Ventures LLC est le franchiseur et propriétaire de la marque Shift Arcade. Les emplacements individuels de Shift Arcade sont des entreprises indépendantes. Chaque emplacement maintient ses propres Conditions d'utilisation et Politique de confidentialité régissant les réservations, les expériences sur site, les paiements,
                les dérogations et les communications spécifiques à l'emplacement.
            </p>
            <p>Les conditions spécifiques à l'emplacement peuvent être trouvées sur les sites Web des emplacements respectifs (par exemple :</p>
            <p>
                <a href="https://sanramon.shiftarcade.com/privacy-terms"> https://sanramon.shiftarcade.com/privacy-terms </a>
            </p>

            <h2><strong>2. Portée de cette politique</strong></h2>
            <p>Cette Politique s'applique lorsqu'un individu :</p>
            <ul>
                <li>Soumet un formulaire sur un site Web de Shift Arcade ou Shift Arcade Ventures</li>
                <li>Choisit de recevoir des communications par SMS ou e-mail</li>
                <li>Demande des informations sur les emplacements ou les opportunités de franchise de Shift Arcade</li>
                <li>S'inscrit pour des mises à jour avant qu'un emplacement spécifique ne soit sélectionné</li>
            </ul>
            <p>Une fois qu'un client s'engage directement avec un emplacement spécifique de Shift Arcade (par exemple, en effectuant une réservation), les propres Conditions d'utilisation et Politique de confidentialité de cet emplacement régiront la relation pour ces services.</p>

            <h2><strong>3. Programmes de communications &amp; de messagerie</strong></h2>

            <h3><strong>3.1 Objectif des communications</strong></h3>
            <p>En choisissant de recevoir des communications, les individus peuvent recevoir des messages d'information et de service, y compris mais sans s'y limiter :</p>
            <ul>
                <li>Réponses aux demandes</li>
                <li>Mises à jour liées à Shift Arcade ou au réseau Shift Arcade</li>
                <li>Suivis de demandes de franchise (pour les franchisés potentiels)</li>
                <li>Engagement client général ou mises à jour d'information</li>
            </ul>

            <p><strong>Distinction importante (pour plus de clarté, pas de séparation) :</strong></p>
            <ul>
                <li>Les demandes de franchise reçoivent des communications uniquement liées au processus de découverte de franchise.</li>
                <li>Les communications liées aux clients sont limitées à un engagement général, non spécifique à un emplacement, sauf si et jusqu'à ce que le client s'engage avec un emplacement spécifique.</li>
            </ul>
            <p>Les données collectées pour les demandes de franchise sont conservées uniquement par Shift Arcade Ventures LLC et ne sont pas partagées avec les emplacements de franchise individuels.</p>

            <h3><strong>3.2 Consentement SMS &amp; Désinscription</strong></h3>
            <p>En choisissant de recevoir des communications par SMS, vous acceptez de recevoir des messages texte de Shift Arcade Ventures LLC.</p>
            <ul>
                <li>La fréquence des messages varie en fonction de l'engagement</li>
                <li>Des frais de message et de données peuvent s'appliquer</li>
                <li>Les opérateurs ne sont pas responsables des messages retardés ou non livrés</li>
            </ul>
            <p>Vous pouvez annuler les messages SMS à tout moment en répondant <strong>STOP</strong>.</p>
            <p>Vous pouvez demander de l'aide en répondant <strong>AIDE</strong>.</p>
            <p>Après vous être désabonné, vous recevrez un message de confirmation et aucun autre message ne sera envoyé à moins que vous ne vous réabonnez.</p>

            <h2><strong>4. Informations que nous collectons</strong></h2>
            <p>Nous pouvons collecter les informations suivantes lorsque vous interagissez avec nous :</p>
            <ul>
                <li>Nom</li>
                <li>Numéro de téléphone</li>
                <li>Adresse e-mail</li>
                <li>Informations fournies volontairement via des formulaires ou des messages</li>
            </ul>
            <p>Ces informations sont collectées uniquement à des fins commerciales légitimes liées à la communication, au traitement des demandes et à l'engagement client ou franchise.</p>

            <h2><strong>5. Comment nous utilisons les informations</strong></h2>
            <p>Les informations collectées peuvent être utilisées pour :</p>
            <ul>
                <li>Répondre aux demandes</li>
                <li>Fournir les informations demandées</li>
                <li>Communiquer des mises à jour liées à votre intérêt exprimé</li>
                <li>Améliorer les processus de communication et de support</li>
                <li>Maintenir la conformité avec les exigences légales et de messagerie</li>
            </ul>
            <p>Nous n'utilisons <strong>pas</strong> ces informations à des fins de marketing non liées sans consentement approprié.</p>

            <h2><strong>6. Partage de données &amp; Tiers</strong></h2>
            <p>Nous ne vendons ni ne louons les informations personnelles.</p>
            <p>Nous pouvons utiliser des prestataires de services de confiance (tels que des plateformes CRM, e-mail ou SMS) uniquement pour soutenir les communications et les opérations. Ces prestataires sont contractuellement tenus de protéger les données et de se conformer aux lois sur la confidentialité applicables.</p>
            <p><strong>Les données d'adhésion aux messages texte et le consentement ne sont jamais partagés</strong>, sauf avec les agrégateurs et les prestataires nécessaires pour fournir les services de messagerie.</p>

            <h2><strong>7. Sécurité des données</strong></h2>
            <p>Nous prenons des mesures administratives, techniques et physiques raisonnables pour protéger les informations personnelles. Bien qu'aucun système ne puisse être garanti à 100 % sécurisé, nous utilisons des mesures de protection commercialement raisonnables pour protéger les données contre l'accès non autorisé ou l'utilisation abusive.</p>

            <h2><strong>8. Conformité aux lois</strong></h2>
            <p>Nous nous conformons aux lois locales, étatiques et fédérales applicables, y compris les réglementations sur la messagerie mobile et les normes de l'industrie (y compris les directives TCPA et CTIA).</p>
            <p>En participant à nos communications, vous reconnaissez et acceptez de vous conformer à toutes les lois applicables.</p>

            <h2><strong>9. Modifications de cette politique</strong></h2>
            <p>Nous pouvons mettre à jour cette Politique de temps à autre. Les mises à jour seront publiées à :</p>
            <p>
                <strong>
                    <a href="https://shiftarcade.com/privacy-terms"> https://shiftarcade.com/privacy-terms </a>
                </strong>
            </p>
            <p>La participation continue aux communications après les mises à jour constitue une acceptation de la Politique révisée.</p>

            <h2><strong>10. Informations de contact</strong></h2>
            <p>Pour toute question concernant cette Politique ou nos pratiques en matière de données, veuillez contacter :</p>
            <p><strong>Shift Arcade Ventures LLC</strong></p>
            <p>Email : <strong>franchise@shiftarcade.com</strong></p>
        </div>
        <hr />
        <h2><strong>Conditions d'abonnement au Club Apex</strong></h2>

        <h3><strong>Facturation de l'abonnement &amp; Durée minimale</strong></h3>
        <p>Le Club Apex est un <strong>abonnement mensuel récurrent</strong>. En s'inscrivant au Club Apex, le client autorise Shift Arcade à débiter automatiquement le mode de paiement sélectionné <strong>chaque mois</strong> au tarif d'abonnement publié.</p>
        <p>
            Tous les abonnements au Club Apex ont un
            <strong>engagement minimum de deux (2) mois</strong>. L'abonnement ne peut pas être annulé pendant la période initiale de deux mois.
        </p>
        <p>
            Après que la durée minimale a été satisfaite, l'abonnement se poursuivra sur une
            <strong>base mensuelle</strong> sauf annulation par le client.
        </p>

        <h3><strong>Renouvellement &amp; Annulation</strong></h3>
        <p>Après la période minimale initiale de deux mois, le client peut annuler l'abonnement à tout moment en fournissant un avis via son compte ou en contactant directement l'emplacement.</p>
        <p>Les annulations prennent effet à la <strong>fin de la période de facturation en cours</strong>. Aucun remboursement partiel n'est accordé pour le temps, les crédits ou les avantages non utilisés au sein d'une période de facturation.</p>
        <p>Pour annuler l'adhésion au Club Apex, visitez votre tableau de bord de compte.</p>

        <h3><strong>Crédits, Avantages &amp; Utilisation</strong></h3>
        <p>Les avantages de l'abonnement, y compris les crédits mensuels ou l'accès à tarif réduit, sont émis <strong>chaque cycle de facturation</strong> et sont destinés à être utilisés pendant la période d'abonnement active.</p>
        <p>Les crédits ou avantages non utilisés :</p>
        <ul>
            <li>Ne se convertissent pas en espèces</li>
            <li>Ne sont pas transférables</li>
            <li>Peuvent expirer si l'abonnement est annulé, selon les termes spécifiques du plan Club Apex</li>
        </ul>
        <p>Les avantages de l'abonnement sont soumis à disponibilité et peuvent varier selon l'emplacement.</p>

        <h3><strong>Aucun remboursement pour utilisation manquée</strong></h3>
        <p>
            Le fait de ne pas utiliser les avantages du Club Apex pendant une période de facturation ne constitue pas un motif de remboursement ou de crédit. L'abonnement fournit
            <strong>accès et éligibilité</strong>, pas une utilisation garantie.
        </p>

        <h3><strong>Modifications des conditions d'abonnement</strong></h3>
        <p>Shift Arcade se réserve le droit de modifier les tarifs, les avantages ou les conditions du Club Apex avec un préavis raisonnable. Toute modification s'appliquera de manière prospective et sera communiquée par e-mail, SMS ou termes publiés.</p>

        <h3><strong>Reconnaissance</strong></h3>
        <p>En s'inscrivant au Club Apex, le client reconnaît et accepte que :</p>
        <ul>
            <li>L'abonnement est facturé <strong>mensuellement</strong></li>
            <li>Une <strong>durée minimale de deux mois</strong> s'applique</li>
            <li>Les frais continueront automatiquement sauf annulation après la durée minimale</li>
        </ul>
    </div>
</template>
